import { render, staticRenderFns } from "./KlantLogos.vue?vue&type=template&id=bf4b08b2&"
import script from "./KlantLogos.vue?vue&type=script&lang=js&"
export * from "./KlantLogos.vue?vue&type=script&lang=js&"
import style0 from "./KlantLogos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports